import React, { useState } from 'react';
import axios from 'axios';
import { useParams, Navigate } from 'react-router-dom';

const MagicLinkConfirm = ({ updateUserData }) => {
    const { token } = useParams();
    const [error, setError] = useState(null);
    const [loggedIn, setLoggedIn] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleClick = async () => {
        setError(null);
        setSubmitting(true);
        try {
            const response = await axios.post('/api/v1/user/magic-link', { token });
            updateUserData(response.data);
            setLoggedIn(true);
        } catch (err) {
            setError(err.response?.data?.error || 'An error occurred while logging in.');
            setSubmitting(false);
        }
    };

    if (loggedIn) {
        return <Navigate to="/myTeam" />;
    }

    return (
        <div>
            <h2>Log In</h2>
            {error ? (
                <div className="alert alert-danger">{error}</div>
            ) : (
                <p>Click below to finish logging in.</p>
            )}
            <button className="btn btn-primary" onClick={handleClick} disabled={submitting}>{submitting ? 'Logging in…' : 'Finish logging in'}</button>
        </div>
    );
};

export default MagicLinkConfirm;
